import { Ingredient, IngredientMovement, StockAlert, PurchaseOrder, LocationStock, getIngredientForLocation } from '@/types/ingredient.types';

// Locales de ejemplo
export const mockLocations = [
  { id: 'loc-1', name: 'Sede Principal' },
  { id: 'loc-2', name: 'Sucursal Norte' },
  { id: 'loc-3', name: 'Sucursal Sur' },
  { id: 'loc-4', name: 'Local Centro' },
  { id: 'loc-5', name: 'Miraflores' },
  { id: 'loc-6', name: 'San Isidro' },
  { id: 'loc-7', name: 'La Molina' },
  { id: 'loc-8', name: 'Surco' },
  { id: 'loc-9', name: 'Barranco' }
];

// Mock de ingredientes típicos de una sanguchería
export const mockIngredients: Ingredient[] = [
  // PANES
  {
    id: 'ing-001',
    name: 'Pan Francés',
    description: 'Pan francés fresco para sandwiches',
    category: 'panes',
    unit: 'unidad',
    supplier: 'Panadería Don José',
    globalCostPerUnit: 0.30,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 150,
        minStock: 50,
        maxStock: 300,
        costPerUnit: 0.30,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 80,
        minStock: 30,
        maxStock: 200,
        costPerUnit: 0.32,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 120,
        minStock: 40,
        maxStock: 250,
        costPerUnit: 0.30,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 60,
        minStock: 25,
        maxStock: 150,
        costPerUnit: 0.35,
        isActive: true
      },
      {
        locationId: 'loc-5',
        locationName: 'Miraflores',
        currentStock: 20, // STOCK BAJO - para testing
        minStock: 35,
        maxStock: 180,
        costPerUnit: 0.33,
        isActive: true
      },
      {
        locationId: 'loc-6',
        locationName: 'San Isidro',
        currentStock: 95,
        minStock: 40,
        maxStock: 220,
        costPerUnit: 0.31,
        isActive: true
      },
      {
        locationId: 'loc-7',
        locationName: 'La Molina',
        currentStock: 15, // STOCK BAJO - para testing
        minStock: 30,
        maxStock: 160,
        costPerUnit: 0.34,
        isActive: true
      },
      {
        locationId: 'loc-8',
        locationName: 'Surco',
        currentStock: 110,
        minStock: 45,
        maxStock: 240,
        costPerUnit: 0.32,
        isActive: true
      },
      {
        locationId: 'loc-9',
        locationName: 'Barranco',
        currentStock: 25, // STOCK BAJO - para testing
        minStock: 30,
        maxStock: 140,
        costPerUnit: 0.36,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-002',
    name: 'Pan Integral',
    description: 'Pan integral para opciones saludables',
    category: 'panes',
    unit: 'unidad',
    supplier: 'Panadería Don José',
    globalCostPerUnit: 0.40,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 80,
        minStock: 30,
        maxStock: 150,
        costPerUnit: 0.40,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 45,
        minStock: 20,
        maxStock: 100,
        costPerUnit: 0.42,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 65,
        minStock: 25,
        maxStock: 120,
        costPerUnit: 0.40,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 35,
        minStock: 15,
        maxStock: 80,
        costPerUnit: 0.45,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // CARNES
  {
    id: 'ing-003',
    name: 'Jamón de Pierna',
    description: 'Jamón de pierna premium',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Embutidos San Fernando',
    globalCostPerUnit: 18.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 15.5,
        minStock: 5,
        maxStock: 30,
        costPerUnit: 18.00,
        lastRestockDate: '2024-08-01T08:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 8.2,
        minStock: 3,
        maxStock: 20,
        costPerUnit: 18.50,
        lastRestockDate: '2024-08-01T08:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 12.1,
        minStock: 4,
        maxStock: 25,
        costPerUnit: 18.00,
        lastRestockDate: '2024-08-01T08:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 6.8,
        minStock: 2,
        maxStock: 15,
        costPerUnit: 19.00,
        lastRestockDate: '2024-08-01T08:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-004',
    name: 'Pollo Deshilachado',
    description: 'Pechuga de pollo cocida y deshilachada',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Avícola La Preferida',
    globalCostPerUnit: 15.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 12.3,
        minStock: 5,
        maxStock: 25,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-30T10:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 7.5,
        minStock: 3,
        maxStock: 15,
        costPerUnit: 15.50,
        lastRestockDate: '2024-07-30T10:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 9.8,
        minStock: 4,
        maxStock: 20,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-30T10:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 5.2,
        minStock: 2,
        maxStock: 12,
        costPerUnit: 16.00,
        lastRestockDate: '2024-07-30T10:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-005',
    name: 'Chorizo Parrillero',
    description: 'Chorizo especial para sandwiches',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Embutidos San Fernando',
    globalCostPerUnit: 22.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 8.7,
        minStock: 3,
        maxStock: 20,
        costPerUnit: 22.00,
        lastRestockDate: '2024-07-28T15:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 4.5,
        minStock: 2,
        maxStock: 12,
        costPerUnit: 22.50,
        lastRestockDate: '2024-07-28T15:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 6.8,
        minStock: 2.5,
        maxStock: 15,
        costPerUnit: 22.00,
        lastRestockDate: '2024-07-28T15:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 3.2,
        minStock: 1.5,
        maxStock: 10,
        costPerUnit: 23.00,
        lastRestockDate: '2024-07-28T15:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // LÁCTEOS
  {
    id: 'ing-006',
    name: 'Queso Edam',
    description: 'Queso Edam en láminas',
    category: 'lacteos',
    unit: 'kg',
    supplier: 'Lácteos Gloria',
    globalCostPerUnit: 24.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 5.2,
        minStock: 2,
        maxStock: 15,
        costPerUnit: 24.00,
        expirationDate: '2024-08-15T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 3.1,
        minStock: 1.5,
        maxStock: 10,
        costPerUnit: 24.50,
        expirationDate: '2024-08-15T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 4.0,
        minStock: 1.5,
        maxStock: 12,
        costPerUnit: 24.00,
        expirationDate: '2024-08-15T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 2.3,
        minStock: 1,
        maxStock: 8,
        costPerUnit: 25.00,
        expirationDate: '2024-08-15T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-007',
    name: 'Queso Mozzarella',
    description: 'Queso mozzarella para derretir',
    category: 'lacteos',
    unit: 'kg',
    supplier: 'Lácteos Gloria',
    globalCostPerUnit: 26.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 3.8,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 26.00,
        expirationDate: '2024-08-12T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 1.8,
        minStock: 1,
        maxStock: 6,
        costPerUnit: 26.50,
        expirationDate: '2024-08-12T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 2.5,
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 26.00,
        expirationDate: '2024-08-12T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 1.2,
        minStock: 0.5,
        maxStock: 5,
        costPerUnit: 27.00,
        expirationDate: '2024-08-12T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // VEGETALES
  {
    id: 'ing-008',
    name: 'Tomate',
    description: 'Tomate fresco en rodajas',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 3.50,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 8.5,
        minStock: 3,
        maxStock: 20,
        costPerUnit: 3.50,
        expirationDate: '2024-08-05T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 5.2,
        minStock: 2,
        maxStock: 12,
        costPerUnit: 3.70,
        expirationDate: '2024-08-05T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 7.1,
        minStock: 2.5,
        maxStock: 15,
        costPerUnit: 3.50,
        expirationDate: '2024-08-05T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 4.3,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 3.80,
        expirationDate: '2024-08-05T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-009',
    name: 'Lechuga Americana',
    description: 'Lechuga fresca y crocante',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 4.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 4.2,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 4.00,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 2.8,
        minStock: 1.5,
        maxStock: 6,
        costPerUnit: 4.20,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 3.5,
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 4.00,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 2.1,
        minStock: 1,
        maxStock: 5,
        costPerUnit: 4.50,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-010',
    name: 'Cebolla Blanca',
    description: 'Cebolla blanca en juliana',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 2.50,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 6.7,
        minStock: 2,
        maxStock: 15,
        costPerUnit: 2.50,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 4.2,
        minStock: 1.5,
        maxStock: 10,
        costPerUnit: 2.70,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 5.8,
        minStock: 2,
        maxStock: 12,
        costPerUnit: 2.50,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 3.1,
        minStock: 1,
        maxStock: 8,
        costPerUnit: 2.80,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-011',
    name: 'Palta',
    description: 'Palta Hass madura',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 8.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 5.3,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 8.00,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 3.1,
        minStock: 1,
        maxStock: 6,
        costPerUnit: 8.50,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 4.7,
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 8.00,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 2.8,
        minStock: 1,
        maxStock: 5,
        costPerUnit: 9.00,
        expirationDate: '2024-08-03T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // SALSAS
  {
    id: 'ing-012',
    name: 'Mayonesa',
    description: 'Mayonesa Alacena',
    category: 'salsas',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 12.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 4.5,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 12.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 2.8,
        minStock: 1.5,
        maxStock: 6,
        costPerUnit: 12.50,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 3.5,
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 12.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 2.1,
        minStock: 1,
        maxStock: 5,
        costPerUnit: 13.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-013',
    name: 'Ketchup',
    description: 'Ketchup Alacena',
    category: 'salsas',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 10.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 3.2,
        minStock: 1,
        maxStock: 8,
        costPerUnit: 10.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 2.1,
        minStock: 0.5,
        maxStock: 5,
        costPerUnit: 10.50,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 2.8,
        minStock: 1,
        maxStock: 6,
        costPerUnit: 10.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 1.5,
        minStock: 0.5,
        maxStock: 4,
        costPerUnit: 11.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-014',
    name: 'Mostaza',
    description: 'Mostaza americana',
    category: 'salsas',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 11.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 2.8,
        minStock: 1,
        maxStock: 6,
        costPerUnit: 11.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 1.5,
        minStock: 0.5,
        maxStock: 4,
        costPerUnit: 11.50,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 2.1,
        minStock: 0.5,
        maxStock: 5,
        costPerUnit: 11.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 1.2,
        minStock: 0.5,
        maxStock: 3,
        costPerUnit: 12.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-015',
    name: 'Ají Verde',
    description: 'Salsa de ají verde casera',
    category: 'salsas',
    unit: 'lt',
    supplier: 'Producción propia',
    globalCostPerUnit: 15.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 2.5,
        minStock: 1,
        maxStock: 5,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-31T14:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 1.2,
        minStock: 0.5,
        maxStock: 3,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-31T14:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 1.8,
        minStock: 0.5,
        maxStock: 4,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-31T14:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 1.0,
        minStock: 0.5,
        maxStock: 2,
        costPerUnit: 15.00,
        lastRestockDate: '2024-07-31T14:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // BEBIDAS
  {
    id: 'ing-016',
    name: 'Gaseosa Inca Kola 500ml',
    description: 'Gaseosa personal',
    category: 'bebidas',
    unit: 'unidad',
    supplier: 'Coca Cola Company',
    globalCostPerUnit: 2.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 48,
        minStock: 24,
        maxStock: 120,
        costPerUnit: 2.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 32,
        minStock: 15,
        maxStock: 80,
        costPerUnit: 2.10,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 45,
        minStock: 20,
        maxStock: 100,
        costPerUnit: 2.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 28,
        minStock: 12,
        maxStock: 60,
        costPerUnit: 2.20,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-017',
    name: 'Gaseosa Coca Cola 500ml',
    description: 'Gaseosa personal',
    category: 'bebidas',
    unit: 'unidad',
    supplier: 'Coca Cola Company',
    globalCostPerUnit: 2.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 36,
        minStock: 24,
        maxStock: 120,
        costPerUnit: 2.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 28,
        minStock: 15,
        maxStock: 80,
        costPerUnit: 2.10,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 42,
        minStock: 20,
        maxStock: 100,
        costPerUnit: 2.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 24,
        minStock: 12,
        maxStock: 60,
        costPerUnit: 2.20,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // CONDIMENTOS
  {
    id: 'ing-018',
    name: 'Sal',
    description: 'Sal de mesa',
    category: 'condimentos',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 1.50,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 5.0,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 1.50,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 3.2,
        minStock: 1,
        maxStock: 6,
        costPerUnit: 1.60,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 4.1,
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 1.50,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 2.5,
        minStock: 1,
        maxStock: 5,
        costPerUnit: 1.70,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-019',
    name: 'Pimienta',
    description: 'Pimienta molida',
    category: 'condimentos',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 45.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 0.5,
        minStock: 0.2,
        maxStock: 2,
        costPerUnit: 45.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 0.3,
        minStock: 0.1,
        maxStock: 1,
        costPerUnit: 46.00,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 0.4,
        minStock: 0.15,
        maxStock: 1.5,
        costPerUnit: 45.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 0.2,
        minStock: 0.1,
        maxStock: 0.8,
        costPerUnit: 47.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // EXTRAS
  {
    id: 'ing-020',
    name: 'Huevo Frito',
    description: 'Huevo frito preparado',
    category: 'otros',
    unit: 'unidad',
    supplier: 'Granja El Rocío',
    globalCostPerUnit: 0.80,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 30,
        minStock: 12,
        maxStock: 60,
        costPerUnit: 0.80,
        expirationDate: '2024-08-02T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 18,
        minStock: 8,
        maxStock: 40,
        costPerUnit: 0.85,
        expirationDate: '2024-08-02T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 25,
        minStock: 10,
        maxStock: 50,
        costPerUnit: 0.80,
        expirationDate: '2024-08-02T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 15,
        minStock: 6,
        maxStock: 30,
        costPerUnit: 0.90,
        expirationDate: '2024-08-02T00:00:00Z',
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-021',
    name: 'Papas al Hilo',
    description: 'Papas fritas al hilo',
    category: 'otros',
    unit: 'kg',
    supplier: 'Proveedor de Papas',
    globalCostPerUnit: 8.00,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 10.0,
        minStock: 5,
        maxStock: 20,
        costPerUnit: 8.00,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 6.5,
        minStock: 3,
        maxStock: 12,
        costPerUnit: 8.50,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 8.2,
        minStock: 4,
        maxStock: 16,
        costPerUnit: 8.00,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 5.1,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 9.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // INGREDIENTE ADICIONAL CON PROBLEMAS CRÍTICOS PARA TESTING
  {
    id: 'ing-022',
    name: 'Leche para Preparaciones',
    description: 'Leche evaporada para salsas',
    category: 'lacteos',
    unit: 'lt',
    supplier: 'Lácteos Gloria',
    globalCostPerUnit: 4.50,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 1.5, // STOCK BAJO
        minStock: 3,
        maxStock: 15,
        costPerUnit: 4.50,
        expirationDate: '2024-08-23T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 0.8, // STOCK CRÍTICO
        minStock: 2,
        maxStock: 10,
        costPerUnit: 4.70,
        expirationDate: '2024-08-22T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 2.1,
        minStock: 2.5,
        maxStock: 12,
        costPerUnit: 4.50,
        expirationDate: '2024-08-24T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 0.5, // STOCK CRÍTICO
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 4.80,
        expirationDate: '2024-08-22T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      },
      {
        locationId: 'loc-5',
        locationName: 'Miraflores',
        currentStock: 1.2, // STOCK BAJO
        minStock: 2,
        maxStock: 10,
        costPerUnit: 4.60,
        expirationDate: '2024-08-23T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      },
      {
        locationId: 'loc-6',
        locationName: 'San Isidro',
        currentStock: 3.5,
        minStock: 2.5,
        maxStock: 12,
        costPerUnit: 4.55,
        expirationDate: '2024-08-25T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-7',
        locationName: 'La Molina',
        currentStock: 0.3, // STOCK CRÍTICO
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 4.75,
        expirationDate: '2024-08-22T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      },
      {
        locationId: 'loc-8',
        locationName: 'Surco',
        currentStock: 2.8,
        minStock: 2,
        maxStock: 10,
        costPerUnit: 4.65,
        expirationDate: '2024-08-26T00:00:00Z',
        isActive: true
      },
      {
        locationId: 'loc-9',
        locationName: 'Barranco',
        currentStock: 0.7, // STOCK CRÍTICO
        minStock: 1.5,
        maxStock: 8,
        costPerUnit: 4.85,
        expirationDate: '2024-08-23T00:00:00Z', // PRÓXIMO A VENCER
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  
  {
    id: 'ing-023',
    name: 'Aceite Vegetal',
    description: 'Aceite para frituras',
    category: 'condimentos',
    unit: 'lt',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 8.50,
    locationStocks: [
      {
        locationId: 'loc-1',
        locationName: 'Sede Principal',
        currentStock: 8.5,
        minStock: 5,
        maxStock: 20,
        costPerUnit: 8.50,
        isActive: true
      },
      {
        locationId: 'loc-2',
        locationName: 'Sucursal Norte',
        currentStock: 2.1, // STOCK BAJO
        minStock: 3,
        maxStock: 12,
        costPerUnit: 8.70,
        isActive: true
      },
      {
        locationId: 'loc-3',
        locationName: 'Sucursal Sur',
        currentStock: 6.8,
        minStock: 4,
        maxStock: 15,
        costPerUnit: 8.50,
        isActive: true
      },
      {
        locationId: 'loc-4',
        locationName: 'Local Centro',
        currentStock: 1.5, // STOCK BAJO
        minStock: 2.5,
        maxStock: 10,
        costPerUnit: 8.90,
        isActive: true
      },
      {
        locationId: 'loc-5',
        locationName: 'Miraflores',
        currentStock: 0.8, // STOCK CRÍTICO
        minStock: 2,
        maxStock: 10,
        costPerUnit: 8.80,
        isActive: true
      },
      {
        locationId: 'loc-6',
        locationName: 'San Isidro',
        currentStock: 7.2,
        minStock: 3.5,
        maxStock: 14,
        costPerUnit: 8.60,
        isActive: true
      },
      {
        locationId: 'loc-7',
        locationName: 'La Molina',
        currentStock: 1.2, // STOCK BAJO
        minStock: 2.5,
        maxStock: 10,
        costPerUnit: 8.85,
        isActive: true
      },
      {
        locationId: 'loc-8',
        locationName: 'Surco',
        currentStock: 5.8,
        minStock: 3,
        maxStock: 12,
        costPerUnit: 8.75,
        isActive: true
      },
      {
        locationId: 'loc-9',
        locationName: 'Barranco',
        currentStock: 0.5, // STOCK CRÍTICO
        minStock: 2,
        maxStock: 8,
        costPerUnit: 9.00,
        isActive: true
      }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },

  // INGREDIENTES ADICIONALES PARA TESTING DE PAGINACIÓN
  {
    id: 'ing-024',
    name: 'Mantequilla',
    description: 'Mantequilla sin sal',
    category: 'lacteos',
    unit: 'kg',
    supplier: 'Lácteos Gloria',
    globalCostPerUnit: 16.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 0.8, minStock: 2, maxStock: 8, costPerUnit: 16.00, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 2.3, minStock: 1.5, maxStock: 6, costPerUnit: 16.50, isActive: true }, // STOCK OK
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 2.8, minStock: 2, maxStock: 7, costPerUnit: 16.00, isActive: true }, // STOCK OK
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.5, minStock: 1, maxStock: 5, costPerUnit: 17.00, isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.2, minStock: 1.5, maxStock: 6, costPerUnit: 16.80, isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 3.1, minStock: 1.5, maxStock: 6, costPerUnit: 16.20, isActive: true }, // STOCK OK
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.4, minStock: 1.5, maxStock: 6, costPerUnit: 17.20, isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 2.9, minStock: 1.5, maxStock: 6, costPerUnit: 16.50, isActive: true }, // STOCK OK
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.3, minStock: 1, maxStock: 4, costPerUnit: 17.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-025',
    name: 'Tocino',
    description: 'Tocino ahumado en tiras',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Embutidos San Fernando',
    globalCostPerUnit: 28.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 4.5, minStock: 3, maxStock: 12, costPerUnit: 28.00, isActive: true }, // STOCK OK
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 1.2, minStock: 2, maxStock: 8, costPerUnit: 28.50, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 3.8, minStock: 2.5, maxStock: 10, costPerUnit: 28.00, isActive: true }, // STOCK OK
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.8, minStock: 1.5, maxStock: 6, costPerUnit: 29.00, isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.5, minStock: 2, maxStock: 8, costPerUnit: 28.80, isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 3.2, minStock: 2.5, maxStock: 10, costPerUnit: 28.20, isActive: true }, // STOCK OK
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.9, minStock: 2, maxStock: 8, costPerUnit: 29.20, isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 3.8, minStock: 2, maxStock: 8, costPerUnit: 28.50, isActive: true }, // STOCK OK
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.6, minStock: 1.5, maxStock: 6, costPerUnit: 29.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-026',
    name: 'Apio',
    description: 'Apio fresco',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 3.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 2.8, minStock: 2, maxStock: 8, costPerUnit: 3.00, isActive: true }, // STOCK OK - Sin fecha vencimiento
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.9, minStock: 1.5, maxStock: 6, costPerUnit: 3.20, expirationDate: '2024-08-22T00:00:00Z', isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 2.5, minStock: 1.5, maxStock: 6, costPerUnit: 3.00, isActive: true }, // STOCK OK - Sin fecha vencimiento
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.8, minStock: 1, maxStock: 4, costPerUnit: 3.30, expirationDate: '2024-08-22T00:00:00Z', isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.5, minStock: 1.5, maxStock: 6, costPerUnit: 3.10, expirationDate: '2024-08-23T00:00:00Z', isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 2.1, minStock: 1.5, maxStock: 6, costPerUnit: 3.05, isActive: true }, // STOCK OK - Sin fecha vencimiento
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.7, minStock: 1.5, maxStock: 6, costPerUnit: 3.25, expirationDate: '2024-08-22T00:00:00Z', isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 2.9, minStock: 1.5, maxStock: 6, costPerUnit: 3.15, isActive: true }, // STOCK OK - Sin fecha vencimiento
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.6, minStock: 1, maxStock: 4, costPerUnit: 3.35, expirationDate: '2024-08-23T00:00:00Z', isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-027',
    name: 'Pimiento Rojo',
    description: 'Pimiento rojo dulce',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 5.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 1.2, minStock: 2, maxStock: 8, costPerUnit: 5.50, expirationDate: '2024-08-24T00:00:00Z', isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.8, minStock: 1.5, maxStock: 6, costPerUnit: 5.70, expirationDate: '2024-08-23T00:00:00Z', isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 1.8, minStock: 1.5, maxStock: 6, costPerUnit: 5.50, expirationDate: '2024-08-25T00:00:00Z', isActive: true },
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.9, minStock: 1, maxStock: 4, costPerUnit: 5.80, expirationDate: '2024-08-23T00:00:00Z', isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.6, minStock: 1.5, maxStock: 6, costPerUnit: 5.60, expirationDate: '2024-08-24T00:00:00Z', isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 2.2, minStock: 1.5, maxStock: 6, costPerUnit: 5.55, expirationDate: '2024-08-26T00:00:00Z', isActive: true },
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.7, minStock: 1.5, maxStock: 6, costPerUnit: 5.75, expirationDate: '2024-08-23T00:00:00Z', isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 1.9, minStock: 1.5, maxStock: 6, costPerUnit: 5.65, expirationDate: '2024-08-27T00:00:00Z', isActive: true },
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.8, minStock: 1, maxStock: 4, costPerUnit: 5.85, expirationDate: '2024-08-24T00:00:00Z', isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-028',
    name: 'Orégano',
    description: 'Orégano seco molido',
    category: 'condimentos',
    unit: 'kg',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 35.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 0.15, minStock: 0.3, maxStock: 1.5, costPerUnit: 35.00, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.08, minStock: 0.2, maxStock: 1, costPerUnit: 36.00, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 0.25, minStock: 0.25, maxStock: 1.2, costPerUnit: 35.00, isActive: true },
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.05, minStock: 0.15, maxStock: 0.8, costPerUnit: 37.00, isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.1, minStock: 0.2, maxStock: 1, costPerUnit: 35.80, isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 0.4, minStock: 0.25, maxStock: 1.2, costPerUnit: 35.20, isActive: true },
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.08, minStock: 0.2, maxStock: 1, costPerUnit: 36.50, isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 0.3, minStock: 0.2, maxStock: 1, costPerUnit: 35.50, isActive: true },
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.06, minStock: 0.15, maxStock: 0.8, costPerUnit: 37.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-029',
    name: 'Vinagre Blanco',
    description: 'Vinagre blanco para aliños',
    category: 'condimentos',
    unit: 'lt',
    supplier: 'Distribuidora ABC',
    globalCostPerUnit: 6.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 1.2, minStock: 2, maxStock: 8, costPerUnit: 6.50, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.8, minStock: 1.5, maxStock: 6, costPerUnit: 6.70, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 1.8, minStock: 1.5, maxStock: 6, costPerUnit: 6.50, isActive: true },
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.5, minStock: 1, maxStock: 4, costPerUnit: 6.90, isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.7, minStock: 1.5, maxStock: 6, costPerUnit: 6.60, isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 2.1, minStock: 1.5, maxStock: 6, costPerUnit: 6.55, isActive: true },
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.6, minStock: 1.5, maxStock: 6, costPerUnit: 6.85, isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 1.9, minStock: 1.5, maxStock: 6, costPerUnit: 6.65, isActive: true },
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.4, minStock: 1, maxStock: 4, costPerUnit: 6.95, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-030',
    name: 'Agua Mineral',
    description: 'Agua mineral 500ml',
    category: 'bebidas',
    unit: 'unidad',
    supplier: 'Distribuidora de Bebidas',
    globalCostPerUnit: 0.80,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 15, minStock: 24, maxStock: 120, costPerUnit: 0.80, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 8, minStock: 15, maxStock: 80, costPerUnit: 0.85, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 22, minStock: 20, maxStock: 100, costPerUnit: 0.80, isActive: true },
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 5, minStock: 12, maxStock: 60, costPerUnit: 0.90, isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 10, minStock: 15, maxStock: 80, costPerUnit: 0.82, isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 35, minStock: 20, maxStock: 100, costPerUnit: 0.78, isActive: true },
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 7, minStock: 15, maxStock: 80, costPerUnit: 0.88, isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 28, minStock: 15, maxStock: 80, costPerUnit: 0.83, isActive: true },
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 6, minStock: 12, maxStock: 60, costPerUnit: 0.92, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-031',
    name: 'Limón',
    description: 'Limón fresco',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 4.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 1.5, minStock: 2, maxStock: 8, costPerUnit: 4.50, expirationDate: '2024-08-25T00:00:00Z', isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.8, minStock: 1.5, maxStock: 6, costPerUnit: 4.70, expirationDate: '2024-08-24T00:00:00Z', isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 1.9, minStock: 1.5, maxStock: 6, costPerUnit: 4.50, expirationDate: '2024-08-26T00:00:00Z', isActive: true },
      { locationId: 'loc-4', locationName: 'Local Centro', currentStock: 0.7, minStock: 1, maxStock: 4, costPerUnit: 4.80, expirationDate: '2024-08-24T00:00:00Z', isActive: true },
      { locationId: 'loc-5', locationName: 'Miraflores', currentStock: 0.9, minStock: 1.5, maxStock: 6, costPerUnit: 4.60, expirationDate: '2024-08-25T00:00:00Z', isActive: true },
      { locationId: 'loc-6', locationName: 'San Isidro', currentStock: 2.3, minStock: 1.5, maxStock: 6, costPerUnit: 4.55, expirationDate: '2024-08-27T00:00:00Z', isActive: true },
      { locationId: 'loc-7', locationName: 'La Molina', currentStock: 0.6, minStock: 1.5, maxStock: 6, costPerUnit: 4.75, expirationDate: '2024-08-24T00:00:00Z', isActive: true },
      { locationId: 'loc-8', locationName: 'Surco', currentStock: 2.1, minStock: 1.5, maxStock: 6, costPerUnit: 4.65, expirationDate: '2024-08-28T00:00:00Z', isActive: true },
      { locationId: 'loc-9', locationName: 'Barranco', currentStock: 0.5, minStock: 1, maxStock: 4, costPerUnit: 4.85, expirationDate: '2024-08-25T00:00:00Z', isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  
  // Nuevos ingredientes para transformaciones
  {
    id: 'ing-032',
    name: 'Pollo Crudo',
    description: 'Pechuga de pollo cruda para transformación',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Avícola La Preferida',
    globalCostPerUnit: 12.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 8.0, minStock: 3, maxStock: 20, costPerUnit: 12.00, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 5.5, minStock: 2, maxStock: 15, costPerUnit: 12.20, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 6.8, minStock: 3, maxStock: 18, costPerUnit: 12.00, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-033',
    name: 'Pollo Cocido',
    description: 'Pechuga de pollo cocida lista para usar',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Avícola La Preferida',
    globalCostPerUnit: 16.00,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 4.2, minStock: 2, maxStock: 15, costPerUnit: 16.00, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 2.8, minStock: 1.5, maxStock: 10, costPerUnit: 16.20, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 3.5, minStock: 2, maxStock: 12, costPerUnit: 16.00, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-034',
    name: 'Palta Molida',
    description: 'Palta procesada y molida para sandwiches',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Mercado Mayorista',
    globalCostPerUnit: 18.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 1.5, minStock: 1, maxStock: 8, costPerUnit: 18.50, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 0.8, minStock: 0.5, maxStock: 5, costPerUnit: 18.80, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 1.2, minStock: 1, maxStock: 6, costPerUnit: 18.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-035',
    name: 'Pan Tostado',
    description: 'Pan francés tostado listo para servir',
    category: 'panes',
    unit: 'unidad',
    supplier: 'Panadería Don José',
    globalCostPerUnit: 0.40,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 80, minStock: 30, maxStock: 200, costPerUnit: 0.40, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 45, minStock: 20, maxStock: 150, costPerUnit: 0.42, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 65, minStock: 25, maxStock: 180, costPerUnit: 0.40, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-036',
    name: 'Jamón Rebanado',
    description: 'Jamón de pierna rebanado fino para sandwiches',
    category: 'carnes',
    unit: 'kg',
    supplier: 'Embutidos Premium',
    globalCostPerUnit: 25.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 3.2, minStock: 2, maxStock: 12, costPerUnit: 25.50, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 1.8, minStock: 1.5, maxStock: 8, costPerUnit: 25.80, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 2.5, minStock: 2, maxStock: 10, costPerUnit: 25.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-037',
    name: 'Papas Fritas',
    description: 'Papas cortadas y fritas listas para servir',
    category: 'otros',
    unit: 'kg',
    supplier: 'Distribuidora de Papas',
    globalCostPerUnit: 8.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 5.5, minStock: 2, maxStock: 15, costPerUnit: 8.50, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 3.2, minStock: 1.5, maxStock: 10, costPerUnit: 8.70, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 4.8, minStock: 2, maxStock: 12, costPerUnit: 8.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  },
  {
    id: 'ing-038',
    name: 'Papas Crudas',
    description: 'Papas peladas y cortadas listas para cocinar',
    category: 'vegetales',
    unit: 'kg',
    supplier: 'Distribuidora de Papas',
    globalCostPerUnit: 3.50,
    locationStocks: [
      { locationId: 'loc-1', locationName: 'Sede Principal', currentStock: 12.0, minStock: 5, maxStock: 25, costPerUnit: 3.50, isActive: true },
      { locationId: 'loc-2', locationName: 'Sucursal Norte', currentStock: 8.5, minStock: 3, maxStock: 20, costPerUnit: 3.60, isActive: true },
      { locationId: 'loc-3', locationName: 'Sucursal Sur', currentStock: 10.2, minStock: 4, maxStock: 22, costPerUnit: 3.50, isActive: true }
    ],
    isActive: true,
    createdAt: '2024-01-01T08:00:00Z',
    updatedAt: '2024-08-01T10:00:00Z'
  }
];

// Mock de movimientos de inventario
export const mockIngredientMovements: IngredientMovement[] = [
  {
    id: 'mov-001',
    ingredientId: 'ing-001',
    type: 'purchase',
    quantity: 100,
    unit: 'unidad',
    previousStock: 50,
    newStock: 150,
    reason: 'Reposición semanal',
    reference: 'PO-2024-001',
    performedBy: 'admin@macartur.pe',
    performedAt: '2024-08-01T08:00:00Z'
  },
  {
    id: 'mov-002',
    ingredientId: 'ing-003',
    type: 'sale',
    quantity: 0.5,
    unit: 'kg',
    previousStock: 16,
    newStock: 15.5,
    reason: 'Venta de sandwiches',
    reference: 'SALE-2024-1234',
    performedBy: 'cajero@macartur.pe',
    performedAt: '2024-08-01T12:30:00Z'
  },
  {
    id: 'mov-003',
    ingredientId: 'ing-008',
    type: 'waste',
    quantity: 2,
    unit: 'kg',
    previousStock: 10.5,
    newStock: 8.5,
    reason: 'Tomates en mal estado',
    performedBy: 'supervisor@macartur.pe',
    performedAt: '2024-08-01T09:00:00Z'
  }
];

// Mock de alertas de stock
export const mockStockAlerts: StockAlert[] = [
  {
    id: 'alert-001',
    ingredientId: 'ing-007',
    ingredient: mockIngredients.find(i => i.id === 'ing-007')!,
    type: 'low_stock',
    message: 'Queso Mozzarella por debajo del mínimo (3.8kg de 2kg min)',
    severity: 'medium',
    createdAt: '2024-08-01T10:00:00Z',
    acknowledged: false
  },
  {
    id: 'alert-002',
    ingredientId: 'ing-011',
    ingredient: mockIngredients.find(i => i.id === 'ing-011')!,
    type: 'expiring_soon',
    message: 'Palta próxima a vencer (2 días restantes)',
    severity: 'high',
    createdAt: '2024-08-01T10:00:00Z',
    acknowledged: false
  }
];

// Mock de órdenes de compra sugeridas
export const mockPurchaseOrder: PurchaseOrder = {
  id: 'po-001',
  orderNumber: 'PO-2024-002',
  supplier: 'Distribuidora General',
  items: [
    {
      ingredientId: 'ing-001',
      ingredient: mockIngredients.find(i => i.id === 'ing-001'),
      quantity: 100,
      unit: 'unidad',
      unitCost: 0.30,
      totalCost: 30.00
    },
    {
      ingredientId: 'ing-003',
      ingredient: mockIngredients.find(i => i.id === 'ing-003'),
      quantity: 10,
      unit: 'kg',
      unitCost: 18.00,
      totalCost: 180.00
    }
  ],
  subtotal: 210.00,
  tax: 37.80,
  total: 247.80,
  status: 'draft',
  orderDate: '2024-08-01T14:00:00Z',
  expectedDate: '2024-08-03T08:00:00Z',
  notes: 'Orden sugerida basada en stock mínimo',
  createdBy: 'system',
  createdAt: '2024-08-01T14:00:00Z',
  updatedAt: '2024-08-01T14:00:00Z'
};

// Helper para obtener ingredientes con stock bajo (usando local principal por defecto)
export const getLowStockIngredients = (): Ingredient[] => {
  return getLowStockIngredientsForLocation('loc-1');
};

// Helper para calcular el valor total del inventario para un local específico
export const getTotalInventoryValue = (locationId: string = 'loc-1'): number => {
  return mockIngredients.reduce((total, ingredient) => {
    const locationStock = ingredient.locationStocks?.find(stock => stock.locationId === locationId);
    if (locationStock) {
      return total + (locationStock.currentStock * locationStock.costPerUnit);
    }
    return total;
  }, 0);
};

// Helper para obtener ingredientes con stock bajo en un local específico
export const getLowStockIngredientsForLocation = (locationId: string = 'loc-1'): Ingredient[] => {
  return mockIngredients.filter(ingredient => {
    const locationStock = ingredient.locationStocks?.find(stock => stock.locationId === locationId);
    return locationStock && locationStock.currentStock <= locationStock.minStock * 1.2;
  }).map(ingredient => getIngredientForLocation(ingredient, locationId));
};

// Helper para obtener ingredientes adaptados al local actual
export const getIngredientsForLocation = (locationId: string = 'loc-1'): Ingredient[] => {
  return mockIngredients.map(ingredient => {
    // Si ya tiene locationStocks, usar esos datos
    if (ingredient.locationStocks && ingredient.locationStocks.length > 0) {
      return getIngredientForLocation(ingredient, locationId);
    }
    
    // Si es un ingrediente legacy, mantener los datos como están
    return ingredient;
  });
};